import { ColumnConfigType } from 'shared/types';
import { BonusesStatisticsItemTableType } from 'entities/bonusStatistics/types';

export const colummConfig: ColumnConfigType<BonusesStatisticsItemTableType>[] = [
  {
    dataFieldName: 'door_code',
    name: 'Код двери',
    width: '5%',
  },
  {
    dataFieldName: 'sales_point_city',
    name: 'Город',
    width: '5%',
  },
  {
    dataFieldName: 'sales_point_address',
    name: 'Адрес ТТ',
    width: '5%',
  },
  {
    dataFieldName: 'sales_point_name',
    name: 'Наименование ТТ',
    width: '5%',
  },
  {
    dataFieldName: 'user_name',
    name: 'Пользователь',
    width: '5%',
  },
  {
    dataFieldName: 'iin',
    name: 'ИИН/ИНН/ПИН',
    width: '5%',
  },
  {
    dataFieldName: 'phone',
    name: 'Номер телефона',
    width: '5%',
  },
  {
    dataFieldName: 'passport',
    name: 'Номер паспорта',
    width: '10%',
  },
  {
    dataFieldName: 'passport_issued_at',
    name: 'Дата выдачи паспорта',
    width: '10%',
  },
  {
    dataFieldName: 'passport_expiration_at',
    name: 'Дата истечения срока паспорта',
    width: '10%',
  },
  {
    dataFieldName: 'transaction_type',
    name: 'Тип операции',
    width: '5%',
  },
  {
    dataFieldName: 'activity_name',
    name: 'Акция',
    width: '5%',
  },
  {
    dataFieldName: 'amount',
    name: 'Количество',
    width: '5%',
  },
  {
    dataFieldName: 'succeed_at',
    name: 'Дата выполнения операции',
    width: '5%',
  },
  {
    dataFieldName: 'expiration_at',
    name: 'Дата истечения срока',
    width: '5%',
  },
  {
    dataFieldName: 'transaction_status',
    name: 'Статус',
    width: '5%',
  },
  {
    dataFieldName: 'id',
    name: 'id операции',
    width: '5%',
  },
  {
    dataFieldName: 'commision',
    name: 'Удержанная комиссия',
    width: '5%',
  },
  {
    dataFieldName: 'amount_fact',
    name: 'Фактическая сумма вывода',
    width: '5%',
  },
];
